export default function PHP_bindec() {
  return (
    <div>
      <h1>PHP_bindec</h1>
    </div>
  );
}
